export const MAP_MODE = {
  ANALYZE: 'mode-analyze',
  FEATURES: 'mode-features',
  MOSAICS: 'mode-mosaics',
  SAVED_SEARCHES: 'mode-saved-searches',
  SEARCH: 'mode-search',
  SUBSCRIPTIONS: 'mode-subscriptions',
} as const;

export const UI_MODES = {
  COMPARE: 'compare',
  NONE: 'none',
  PIXEL_PROVENANCE: 'pixelProvenance',
  SNAPSHOT: 'snapshot',
} as const;

export type UiModesValueType = (typeof UI_MODES)[keyof typeof UI_MODES];

export const MAP_DRAW_TOOLS = {
  DRAW_LOCKED_CIRCLE: 'draw-locked-circle',
  DRAW_LOCKED_RECT: 'draw-locked-rect',
  DRAW_RECT_SUPER_RES: 'draw-rect-super-res',

  DRAW_POLYGON: 'draw-polygon',
  DRAW_CIRCLE: 'draw-circle',
  DRAW_RECT: 'draw-rect',
  DRAW_LINE: 'draw-line',

  EDIT: 'draw-edit',

  NONE: '',
} as const;

export const MAP_DRAW_LAYERS = {
  GEOMETRY: 'geometry',
  MEASURE: 'measure',
  NONE: 'none',
} as const;

export const RIGHT_PANELS = {
  COLORENHANCE: 'colorenhance-drawer',
  PROCESS: 'process-drawer',
  ANALYTICAL_DOWNLOAD: 'analytical-download-drawer',
} as const;

export type RightPanelsValueType =
  (typeof RIGHT_PANELS)[keyof typeof RIGHT_PANELS];
